// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Xwu","textarea":"styles_textarea__-t2oS"};